import axios from 'axios';
import { BASENAME } from './utils/constants/general';
import { getDomain } from './utils/config';

const domain = getDomain();

export const API_STATES = {
	PENDING: 'pending',
	LOADING: 'loading',
	SUCCESS: 'success',
	ERROR: 'error'
};

const axiosInstance = axios.create({
	baseURL: BASENAME + '/api',
	timeout: 120000
});

const api = {
	getAppVersion: () =>
		axiosInstance
			.get(`/appVersion`)
			.then(response => response.data)
			.catch(e => {
				console.error(e);
				return '';
			}),
	gainParametersForTableFromWD: tableDataRequest =>
		axiosInstance
			.post(`/gainTableDataFromWD`, tableDataRequest)
			.then(response => response.data)
			.catch(e => {
				console.error(e);
				return null;
			}),
	gainParametersForTableFromPRT: tableDataRequest =>
		axiosInstance
			.post(`/gainTableDataFromPRT`, tableDataRequest)
			.then(response => response.data)
			.catch(e => {
				console.error(e);
				return null;
			}),
	gainParametersForLinks: linksDataRequest =>
		axiosInstance
			.post(`/gainLinksData`, linksDataRequest)
			.then(response => {
				let data = response.data;
				if (domain === 'onsemi.cn') {
					for (const key in data) {
						let value = data[key];
						if (value && value.length > 0 && value.includes('onsemi.com')) {
							data[key] = value.replace('onsemi.com', 'onsemi.cn');
						}
					}
				}
				return data;
			})
			.catch(e => {
				console.error(e);
				return '';
			}),

	gainLongDescription: defaultMappingName =>
		axiosInstance
			.get(`/gainlongDescription`, { params: { opn: defaultMappingName } })
			.then(response => response.data)
			.catch(e => {
				console.error(e);
				return '';
			}),
	runSimulation: simulationDataRequest =>
		axiosInstance
			.post(`/runSimulation`, simulationDataRequest)
			.then(response => response.data)
			.catch(e => {
				console.error(e);
				return '';
			}),
	getNetlist: simulationDataRequest =>
		axiosInstance
			.post(`/getNetlist`, simulationDataRequest)
			.then(response => response.data)
			.catch(e => {
				console.error(e);
				return '';
			}),
	getRawData: simulationDataRequest =>
		axiosInstance
			.post(`/getRawData`, simulationDataRequest)
			.then(response => response.data)
			.catch(e => {
				console.error(e);
				return '';
			}),
	gainSimilarProductUrlForOpn: defaultMappingName =>
		axiosInstance
			.get(`/gainSimilarProductUrlForOpn`, { params: { opn: defaultMappingName } })
			.then(response => response.data)
			.catch(e => {
				console.error(e);
				return '';
			}),
	sendParams: (opn, inputParams) =>
		axiosInstance
			.post(`/sendParams`, { opn: opn, inputParams: inputParams })
			.then(response => response.data)
			.catch(e => {
				console.error(e);
				return '';
			})
};

export default api;
